import axios from 'axios';

export function fetchCoverageAreas() {
    return axios.get(`/webservice/backoffice/coverage_areas`).then(response => response.data);
}
